

import appsettings from '@/store/app-settings'
import {axiosGet, axiosGetBlob, axiosPost}  from '@/store/api/axiosUtils.js'

const getDocumentTrackingDetail = (complaintId) => {    
    const data = {
        complaintId
    }

    console.log('tracking data', data)
    return axiosGet(appsettings.ocpbComplaintAPIUrl + 'api/Tracking/GetTrackingForDep', data)
};

const getBangkokTrackingDetail = (complaintId) => {    
    const data = {
        complaintId
    }

    console.log('tracking data', data)
    return axiosGet(appsettings.ocpbComplaintAPIUrl + 'api/ComplaintBangkok/GetTrackingForDep', data)
};

const getLastTracking = (complaintId) => {
    const data = {
        complaintId
    }

    return axiosGet(appsettings.ocpbComplaintAPIUrl + 'api/Tracking/GetLastTracking', data)
};

const getClueTrackingDetail = (clueId) => {    
    const data = {
        clueId
    };
    console.log('url', 
        appsettings.ocpbComplaintAPIUrl + 'api/Tracking/GetClueTrackingForDep', 
        data
    );
    return axiosGet(
        appsettings.ocpbComplaintAPIUrl + 'api/Tracking/GetClueTrackingForDep', 
        data
    );
};

const getClueLastTracking = (clueId) => {
    const data = {
        clueId
    }
    console.log('url', 
        appsettings.ocpbComplaintAPIUrl + 'api/Tracking/GetClueLastTracking', 
        data
    );
    return axiosGet(
        appsettings.ocpbComplaintAPIUrl + 'api/Tracking/GetClueLastTracking', 
        data
    );
};

const getFastTrackTrackingForComplaint = (trackingDetailID) => {    
    const data = {
        trackingDetailID
    }

    console.log('tracking data', data)
    return axiosGet(appsettings.ocpbComplaintAPIUrl + 'api/Tracking/GetFastTrackTrackingForComplaint', data)
};

const getFasttrackAttachFile = (attachFileId, companyId) => {    
    const data = {
        attachFileId,
        companyId
    }
    return axiosGetBlob(appsettings.ocpbComplaintAPIUrl + 'api/Tracking/GetFasttrackAttachFile', data)
};

// for get care tracking
const getCareTrackingForComplaint = (code) => {
    const data = {
        code
    }
    return axiosGet(appsettings.ocpbComplaintAPIUrl + 'api/Tracking/GetCareTrackingForComplaint', data)
}

export {
getDocumentTrackingDetail, 
getBangkokTrackingDetail,
getLastTracking,

// for clue
getClueTrackingDetail,
getClueLastTracking,
getFastTrackTrackingForComplaint,
getFasttrackAttachFile,

// for care
getCareTrackingForComplaint
}